import { PUBLIC_PROFILE_STATUSES } from 'constants/user'

export const isPublicProfile = ({ publicStatus }) => publicStatus === PUBLIC_PROFILE_STATUSES.PUBLIC
